(function () {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const autoScrollDelay = 5000;

  function loadCard(card) {
    if (!card || card.classList.contains('is-loaded') || card.classList.contains('is-error')) return;

    const image = card.querySelector('img[data-src]');
    if (!image) {
      card.classList.remove('is-loading');
      card.classList.add('is-loaded');
      return;
    }

    image.addEventListener(
      'load',
      function () {
        card.classList.remove('is-loading');
        card.classList.add('is-loaded');
      },
      { once: true }
    );

    image.addEventListener(
      'error',
      function () {
        card.classList.remove('is-loading');
        card.classList.add('is-error');
      },
      { once: true }
    );

    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  }

  function loadInitialCards(section) {
    const initialCount = desktopQuery.matches ? 5 : 3;
    section.querySelectorAll('[data-ds-before-after-card]').forEach(function (card) {
      const index = Number(card.getAttribute('data-ds-before-after-index') || '0');
      if (index > 0 && index <= initialCount) loadCard(card);
    });
  }

  function observeLazyCards(section) {
    const lazyCards = section.querySelectorAll('.ds-before-after__card--lazy');
    if (!lazyCards.length) return;

    if (!('IntersectionObserver' in window)) {
      lazyCards.forEach(loadCard);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadCard(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '260px 0px' }
    );

    lazyCards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.dsBeforeAfterReady === 'true') return;

    const rail = section.querySelector('[data-ds-before-after-rail]');
    const previousButton = section.querySelector('[data-ds-before-after-prev]');
    const nextButton = section.querySelector('[data-ds-before-after-next]');
    if (!rail || !previousButton || !nextButton) return;

    section.dataset.dsBeforeAfterReady = 'true';
    let autoScrollTimer = null;
    let sectionVisible = false;
    let isLoopResetting = false;
    const originalCards = Array.from(rail.querySelectorAll('[data-ds-before-after-card]'));
    const cloneBuffer = Math.min(5, originalCards.length);

    originalCards.slice(0, cloneBuffer).forEach(function (card) {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ds-before-after-clone', 'true');
      rail.appendChild(clone);
    });

    function getStep() {
      const firstCard = rail.querySelector('[data-ds-before-after-card]');
      if (!firstCard) return 0;

      const railStyle = window.getComputedStyle(rail);
      const gap = Number.parseFloat(railStyle.columnGap || railStyle.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
      previousButton.disabled = !hasOverflow;
      nextButton.disabled = !hasOverflow;
    }

    function scrollOne(direction) {
      const step = getStep();
      if (step <= 0) return;

      const edgeTolerance = 8;
      const lastOriginalLeft = Math.max(0, step * (originalCards.length - 1));
      if (direction < 0 && rail.scrollLeft <= edgeTolerance) {
        rail.scrollTo({ left: lastOriginalLeft, behavior: 'smooth' });
        return;
      }

      rail.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    function resetLoopIfNeeded() {
      if (!cloneBuffer || isLoopResetting) return;

      const resetPoint = getStep() * originalCards.length;
      if (resetPoint <= 0 || rail.scrollLeft < resetPoint - 1) return;

      isLoopResetting = true;
      rail.scrollTo({ left: rail.scrollLeft - resetPoint, behavior: 'auto' });
      window.requestAnimationFrame(function () {
        isLoopResetting = false;
      });
    }

    function stopAutoScroll() {
      if (autoScrollTimer !== null) {
        window.clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    function canAutoScroll() {
      return (
        sectionVisible &&
        !document.hidden &&
        rail.scrollWidth > rail.clientWidth + 2
      );
    }

    function autoAdvance() {
      scrollOne(1);
    }

    function startAutoScroll() {
      stopAutoScroll();
      if (!canAutoScroll()) return;

      autoScrollTimer = window.setInterval(autoAdvance, autoScrollDelay);
    }

    previousButton.addEventListener('click', function () {
      scrollOne(-1);
    });

    nextButton.addEventListener('click', function () {
      scrollOne(1);
    });

    rail.addEventListener('scroll', function () {
      updateButtons();
      window.requestAnimationFrame(resetLoopIfNeeded);
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateButtons();
      window.requestAnimationFrame(resetLoopIfNeeded);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoScroll();
      else startAutoScroll();
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        const wasVisible = sectionVisible;
        sectionVisible = Boolean(entry && entry.isIntersecting);
        if (sectionVisible && !wasVisible) {
          scrollOne(1);
          startAutoScroll();
        } else if (!sectionVisible) {
          stopAutoScroll();
        }
      }, { threshold: [0] });

      visibilityObserver.observe(section);
    } else {
      sectionVisible = true;
      scrollOne(1);
      startAutoScroll();
    }

    loadInitialCards(section);
    observeLazyCards(section);
    updateButtons();
  }

  function initAll(root) {
    const scope = root || document;
    if (scope.matches && scope.matches('[data-ds-before-after]')) initSection(scope);
    scope.querySelectorAll('[data-ds-before-after]').forEach(initSection);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
